export const wpBlockTable = () => {
    const tables = document.querySelectorAll('.wp-block-table');
    const solutionsTables = document.querySelectorAll('.wp-block-table.solutions-table');
    const loadMoreTables = document.querySelectorAll('.wp-block-table.pagination-table');

    if (solutionsTables.length) {
        solutionsTables.forEach(table => {
            const thead = table.querySelector('thead');

            if (thead) {
                const thElements = thead.querySelectorAll('th');

                // Add class to all th elements
                thElements.forEach(th => {
                    th.classList.add('solutions-table__th');
                });

                // Make 2nd th span 4 columns and remove the 3rd, 4th, 5th th elements
                if (thElements.length >= 5) {
                    const secondTh = thElements[1]; // 2nd th (0-indexed)
                    secondTh.setAttribute('colspan', '4');

                    // Remove 3rd, 4th, 5th th elements (indices 2, 3, 4)
                    for (let i = 4; i >= 2; i--) {
                        if (thElements[i]) {
                            thElements[i].remove();
                        }
                    }
                }

                // Make 6th th span 4 columns and remove the 7th, 8th, 9th th elements
                // Note: After removing the previous elements, the 6th th is now at index 2
                const remainingThElements = thead.querySelectorAll('th');
                if (remainingThElements.length >= 5) {
                    const sixthTh = remainingThElements[2]; // Now the 3rd element (0-indexed)
                    sixthTh.setAttribute('colspan', '4');

                    // Remove 7th, 8th, 9th th elements (now at indices 3, 4, 5)
                    for (let i = 5; i >= 3; i--) {
                        if (remainingThElements[i]) {
                            remainingThElements[i].remove();
                        }
                    }
                }
            }
        });
    }

    if (loadMoreTables.length) {
        loadMoreTables.forEach(table => {
            const tbody = table.querySelector('tbody');
            if (!tbody) return;
            
            const trElements = tbody.querySelectorAll('tr');
            const trElementsLength = trElements.length;
            const trElementsPerPage = 5;
            
            // If there are 5 or fewer rows, no pagination needed
            if (trElementsLength <= trElementsPerPage) {
                return;
            }
            
            // Track current visible range
            let currentStartIndex = 0;
            let currentEndIndex = trElementsPerPage;

            // Initialize: hide all rows except the first page
            const updateVisibleRows = () => {
                trElements.forEach((tr, index) => {
                    if (index >= currentStartIndex && index < currentEndIndex) {
                        tr.classList.remove('hidden');
                        tr.style.display = '';
                    } else {
                        tr.classList.add('hidden');
                        tr.style.display = 'none';
                    }
                });
            };

            // Update button state
            const updateButtons = () => {
                const hasPrev = currentStartIndex > 0;
                const hasNext = currentEndIndex < trElementsLength;

                loadPrevButton.disabled = !hasPrev;
                loadNextButton.disabled = !hasNext;
            };

            // Scroll to table top accounting for banner height
            const scrollToTableTop = () => {
                const banner = document.querySelector('.banner');
                const bannerHeight = banner ? banner.offsetHeight : 0;
                const tableTop = table.getBoundingClientRect().top + window.pageYOffset;
                const scrollPosition = tableTop - bannerHeight - 30;
                
                window.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth'
                });
            };

            // Create button container
            const buttonContainer = document.createElement('div');
            buttonContainer.classList.add('table-pagination');
            
            // Create Load Previous button
            const loadPrevButton = document.createElement('button');
            loadPrevButton.classList.add('load-prev-button');
            loadPrevButton.textContent = 'Previous';
            loadPrevButton.disabled = true;

            // Create Load Next button
            const loadNextButton = document.createElement('button');
            loadNextButton.classList.add('load-next-button');
            loadNextButton.textContent = 'Next';
            loadNextButton.disabled = false;

            // Load Previous button handler
            loadPrevButton.addEventListener('click', () => {
                currentEndIndex = currentStartIndex;
                currentStartIndex = Math.max(0, currentStartIndex - trElementsPerPage);
                updateVisibleRows();
                updateButtons();
                scrollToTableTop();
            });

            // Load Next button handler
            loadNextButton.addEventListener('click', () => {
                currentStartIndex = currentEndIndex;
                // Calculate how many rows to show (5 or less if fewer remain)
                const remainingRows = trElementsLength - currentStartIndex;
                const rowsToShow = Math.min(trElementsPerPage, remainingRows);
                currentEndIndex = currentStartIndex + rowsToShow;
                updateVisibleRows();
                updateButtons();
                scrollToTableTop();
            });

            // Append buttons to container
            buttonContainer.appendChild(loadPrevButton);
            buttonContainer.appendChild(loadNextButton);
            table.appendChild(buttonContainer);

            // Initialize - show first 5 rows
            updateVisibleRows();
            updateButtons();
        });
    }

    if (tables.length) {
        tables.forEach(table => {
            const tbody = table.querySelector('tbody');
            const thead = table.querySelector('thead');
            const thElements = thead.querySelectorAll('th');
            const trElements = tbody.querySelectorAll('tr');

            // Add data-label attribute to all td elements
            thElements.forEach((th, thIndex) => {
                trElements.forEach(tr => {
                    const tdElements = tr.querySelectorAll('td');
                    if (tdElements[thIndex]) {
                        tdElements[thIndex].setAttribute('data-label', th.textContent);
                    }
                });
            });

        });
    }
}